<template>
  <div>
    <el-dialog
      :visible="isOpen"
      :show-close="true"
      :before-close="cancel"
      :title="titleName"
      custom-class="table-box-dialog"
      :append-to-body="true"
      top="10vh"
    >
      <div>
        <div
          v-if="getTableData !== null"
          style="float: right; padding: 12px 0px;"
        >
          <el-button
            v-loading="pull_loading"
            size="mini"
            type="primary"
            @click="pull"
          >
            同步
          </el-button>
          <el-input
            v-model="tablep.name"
            style="width: 100px"
            size="mini"
            @change="search"
          />
          <el-button
            size="mini"
            type="primary"
            @click="search"
          >
            搜索
          </el-button>
        </div>
        <!-- 标题表格 -->
        <app-table
          ref="my_table"
          :check="true"
          :table-key="tableKey"
          :tablep="tablep"
          :table-props="{
            'height': '400px'
          }"
          :table-list-data="table_list"
          :get-data="getTableData"
          @select-tr="tableSelectTr"
        />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    getTableData: {
      type: Function,
      default: () => {
        return null;
      },
    },
    pullData: {
      type: Function,
      default: () => {
        return null;
      },
    },
    tableListKey: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableBoxKey: {
      type: String,
      default: '',
    },
    tablep: {
      type: Object,
      default: () => {
        return {
          params: {
            page: 1,
            limit: 10,
          },
        };
      },
    },
    tableId: {
      type: Number,
      default: 0,
    },
    titleName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      table_list: this.dataList,
      select_table_list: [],
      tableKey: this.tableListKey,
      pull_loading: false,
    };
  },
  methods: {
    // 勾选行回调
    tableSelectTr(row) {
      this.select_table_list = row;
    },
    pull() {
      const s = this;
      s.pull_loading = true;
      this.pullData(this.tablep).then(() => {
        s.pull_loading = false;
        s.search();
      }).catch(() => {
        s.pull_loading = false;
      });
    },
    // 搜索
    search() {
      this.$refs.my_table.seekTable();
    },
    // 取消
    cancel() {
      this.$emit('cancel');
    },
    // 提交
    confirm() {
      const data = this.select_table_list;
      this.$emit('confirm', data, this.tableBoxKey, this.tableId);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .table-box-dialog {
  width: auto;
  min-width: 680px;
  max-width: 750px;
  .text-tips {
    color: red;
    line-height: 50px;
  }
  .material-container {
    .material-cord {
      min-height: 286px;
      position: relative;
      .constituency {
        overflow-y: scroll;
        height: 400px;
        width: 100%;
        ul {
          margin: 0;
          padding: 0;
          li {
            position: relative;
            list-style: none;
            border: 0;
            width: 245px;
            margin-top: 16px;
            margin-right: 12px;
            display: inline-block;
            background-color: #ccc;
            .item .img-show img {
              max-width: 100%;
              max-height: 100%;
            }
          }
          li:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .title-list-box {
    height: 375px;
    overflow: auto;
    ul {
      padding: 0;
      li {
        list-style-type: none;
        .title-index {
          display: block;
          float: left;
          width: 36px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          background-color: #edf1f5;
        }
        .title-wrong {
          background-color: red;
          color: #edf1f5;
        }
        .title-input {
          width: 982px;

          input {
            width: 95%;
            height: 36px;
            border: none;
            background: transparent;
          }
        }
        .input-action {
          background-color: #edf1f5;
        }
      }
    }
  }
  .f-left {
    float: left;
  }
  .f-right {
    float: right;
  }
  .label-border {
    width: 140px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    text-align: center;
    border: 1px #dcdee2 solid;
  }
  .el-upload {
    width: 100%;
  }
  .el-upload-dragger {
    width: 100%;
  }
  .el-dialog__footer {
    border-top: 1px #d9d9d9 solid;
    padding: 15px 20px;
  }
  .dialog-footer {
    height: 54px;
    line-height: 54px;
    .thumb-img {
      float: left;
      width: 690px;
      height: 63px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      margin-left: 50px;
      text-align: left;
      .item {
        width: 95px;
        height: 54px;
        display: inline-block;
        text-align: center;
        border: 1px #aaa solid;
        margin: 0 10px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
</style>
